import React from 'react';
import Card from '../Card/Card';
import { cardProps } from '../../Templates/Assessment/Assessment';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'src/apps/maximo-journey-advisor/locales/messages';

type Step4Props = {
  cardInfo1: cardProps;
  cardInfo2: cardProps;
  cardInfo3: cardProps;
  cardInfo4: cardProps;
};

const Step4 = ({ cardInfo1, cardInfo2, cardInfo3, cardInfo4 }: Step4Props) => {
  const intl = useIntl();
  return (
    <div className="result">
      <div className="page_heading_3 mt-01">
        <FormattedMessage {...messages.result_text} />
      </div>
      <div className="bx--row mt-01">
        <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-4">
          <Card
            title={intl.formatMessage(messages.card1_title_text)}
            desc={cardInfo1.description || ''}
            linkText={cardInfo1.linkText || ''}
            linkUrl={cardInfo1.linkUrl || ''}
          />
          <Card
            title={intl.formatMessage(messages.card3_title_text)}
            desc={cardInfo3.description || ''}
            linkText={cardInfo3.linkText || ''}
            linkUrl={cardInfo3.linkUrl || ''}
          />
        </div>
        <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-4">
          <Card
            title={intl.formatMessage(messages.card2_title_text)}
            desc={cardInfo2.description || ''}
            linkText={cardInfo2.linkText || ''}
            linkUrl={cardInfo2.linkUrl || ''}
          />
          <Card
            title={intl.formatMessage(messages.card4_title_text)}
            desc={cardInfo4.description || ''}
            linkText={cardInfo4.linkText}
            linkUrl={cardInfo4.linkUrl}
          />
        </div>
      </div>
    </div>
  );
};

export default Step4;
